import { normalizeTasks } from "../TransactionalFlowTasks";
import { getAsync as _getAsync, patchAsync as _patchAsync } from "../../api";
import { taskStatuses } from "utils/static/workflowsStaticData";
import { dateToString } from "utils/dateUtils";

const BASE_URL = "/flows";

function normalizeData(data) {
    const { tasks, status, startDate: startDateInMillis, endDate: endDateInMillis } = data;

    const startDate = startDateInMillis && new Date(startDateInMillis);
    const endDate = endDateInMillis && new Date(endDateInMillis);

    const taskStatus = status && taskStatuses.find((x) => x.value === status);

    const normalizedTasks = tasks && Array.isArray(tasks) && normalizeTasks(tasks);
    return {
        ...data,
        tasks: normalizedTasks || [],
        statusString: taskStatus ? taskStatus.label : status,
        startDateString: dateToString(startDate),
        endDateString: dateToString(endDate),
    };
}

export async function getOneByIdAsync({ id }) {
    return _getAsync({ url: `${BASE_URL}/${id}`, normalizer: normalizeData });
}

export async function restart({ id }) {
   return _patchAsync({ url: `${BASE_URL}/${id}/restart-flow` });
}

